// extracted by mini-css-extract-plugin
export var drawerContent = "_34-0";
export var valueBlock = "_34-1";
export var valueBlockFrom = "_34-2 _34-1";
export var valueBlockTo = "_34-3 _34-1";